import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScoreSymbol = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "score-symbol_svg__Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 1114.3 1020.99",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("style", { children: ".score-symbol_svg__cls-1{fill:url(#score-symbol_svg__linear-gradient)}.score-symbol_svg__cls-2{fill:#24d5d5}" }), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "score-symbol_svg__linear-gradient",
			x1: 23.39,
			y1: 100.77,
			x2: 802.04,
			y2: 1035.2,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .02,
					stopColor: "#cd7099"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .04,
					stopColor: "#c56d98"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .23,
					stopColor: "#7b5697"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .36,
					stopColor: "#4c4796"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .43,
					stopColor: "#3b4296"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5,
					stopColor: "#3a4a99"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .62,
					stopColor: "#3a61a1"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .77,
					stopColor: "#3a86af"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .79,
					stopColor: "#3a8bb1"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .93,
					stopColor: "#62c7ba"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#78e8c0"
				})
			]
		})] }),
		/* @__PURE__ */ _jsx("path", {
			className: "score-symbol_svg__cls-1",
			d: "M363.85,1020.99C216.91,1020.99,99.36,977.03,0,897.62l97.96-154.56c72.77,55.3,165.13,104.93,272.89,104.93s166.53-41.12,166.53-116.28c0-184.35-495.39-48.21-495.39-431.08C41.98,112.03,194.52,0,393.24,0,512.19,0,615.74,26.95,724.9,117.7l-97.96,150.31c-69.97-56.72-146.94-95.01-230.9-95.01-90.96,0-149.74,43.96-149.74,112.02,0,195.69,493.99,53.89,493.99,428.25,0,177.26-132.94,307.71-376.44,307.71Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "score-symbol_svg__cls-2",
			d: "M813.76,877.5c0-87.9,64.13-140.65,141.76-140.65s141.77,52.75,141.77,140.65-64.14,140.65-141.77,140.65-141.76-52.74-141.76-140.65Z"
		})
	]
});
export default SvgScoreSymbol;
